import Loadable from '../../components/loadable';

const SuspensionAutomationsBanner = Loadable({
  loader: () =>
    import(
      '../../pages/contacts/membership_interruptions/membership_interruption_request/components/suspension_automations_banner'
    ),
});

angular.module('shared').value('SuspensionAutomationsBanner', SuspensionAutomationsBanner);
